/**
 * Generates an numerical array
 **/
export default function makeSequence({ start = 0, end, interval = 1 }) {
    const stepCount = Math.ceil((end - start) / interval);

    return new Array(stepCount).fill(null).map((_, i) => start + interval * i);
}
